import React, { useEffect, useState } from "react";
import { MoonStar } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { getQuietHours, setQuietHours, inQuietHours } from "../lib/winChime";

/* Me → Quiet hours: mutes win chime (device) + push notifications (server) between two IST times */
export const QuietHoursRow = ({ ta }) => {
  const { user, setUser } = useAuth();
  const [qh, setQh] = useState(() => user?.quiet_hours || getQuietHours() || { enabled: false, start: "23:00", end: "06:00" });
  useEffect(() => { if (user?.quiet_hours) { setQh(user.quiet_hours); setQuietHours(user.quiet_hours); } }, [user?.quiet_hours]);
  const save = async (next) => {
    setQh(next); setQuietHours(next);
    try { const { data } = await api.put("/auth/quiet-hours", next); setUser((u) => (u ? { ...u, quiet_hours: data.quiet_hours } : u)); if (next.enabled) toast.success(ta ? `அமைதி நேரம் ${next.start}–${next.end}` : `Quiet ${next.start}–${next.end}`); }
    catch { toast.error(ta ? "சேமிக்க முடியவில்லை" : "Could not save"); }
  };
  const active = inQuietHours(qh);
  return (
    <div className="w-full px-4 py-3.5 border-b border-slate-200" data-testid="me-quiet-hours-row">
      <div className="flex items-center gap-3">
        <MoonStar className={`w-4.5 h-4.5 ${qh.enabled ? "text-indigo-500" : "text-blue-600"}`} />
        <span className="text-sm text-slate-900 flex-1 text-left">{ta ? "அமைதி நேரம் (chime & push mute)" : "Quiet hours (mute chime & pushes)"}{active && <span className="ml-1 text-[10px] font-bold text-indigo-600" data-testid="quiet-hours-active">· {ta ? "இப்போது அமைதி" : "quiet now"}</span>}</span>
        <button onClick={() => save({ ...qh, enabled: !qh.enabled })} data-testid="me-quiet-hours-toggle" className={`w-11 h-6 rounded-full relative transition-colors ${qh.enabled ? "bg-indigo-500" : "bg-slate-300"}`}><span className={`absolute top-0.5 w-5 h-5 bg-white rounded-full shadow transition-all ${qh.enabled ? "left-[22px]" : "left-0.5"}`} /></button>
      </div>
      {qh.enabled && (
        <div className="flex items-center gap-2 mt-2 pl-7 text-xs text-slate-600" data-testid="quiet-hours-times">
          <span>{ta ? "இருந்து" : "From"}</span>
          <input type="time" value={qh.start} onChange={(e) => save({ ...qh, start: e.target.value })} className="rl-card bg-slate-100 px-2 py-1 font-mono" data-testid="quiet-hours-start" />
          <span>{ta ? "வரை" : "to"}</span>
          <input type="time" value={qh.end} onChange={(e) => save({ ...qh, end: e.target.value })} className="rl-card bg-slate-100 px-2 py-1 font-mono" data-testid="quiet-hours-end" />
        </div>
      )}
    </div>
  );
};
